"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getAdobeDataStatus = exports.getAdobeData = exports.init = exports.parseAdobeCookie = exports.getAdobeCookie = exports.reset = exports.extractCookies = exports.getCacheBuster = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("../../constants");

var _logger = _interopRequireDefault(require("../logger"));

var _misc = require("../misc");

var _generateLocalMcid = _interopRequireDefault(require("./generateLocalMcid"));

var _urls = require("../urls");

var _onetrust = require("../onetrust");

var jsCookie = require('js-cookie');

var getCacheBuster = function getCacheBuster(url) {
  var rando = Math.floor(Math.random() * 1000000000);
  var qStringConnector = url.indexOf('?') > -1 ? '&' : '?';
  return "".concat(qStringConnector).concat(_constants.ADOBE.cacheBuster, "=").concat(rando);
};

exports.getCacheBuster = getCacheBuster;

var extractCookies = function extractCookies(_ref) {
  var data = _ref.data;

  if ('data' in data) {
    return extractCookies(data);
  }

  return 'cookies' in data ? data.cookies : null;
};

exports.extractCookies = extractCookies;
var externalResolve;
var adobeDataPromise = new Promise(function (resolve) {
  externalResolve = function externalResolve(value) {
    adobeDataPromiseStatus = 'resolved';
    resolve(value);
  };
});
var adobeDataPromiseStatus = 'uninitialized'; // For testing:

var reset = function reset() {
  adobeDataPromise = new Promise(function (resolve) {
    externalResolve = function externalResolve(value) {
      resolve(value);
    };
  });
};

exports.reset = reset;

var getAdobeCookie = function getAdobeCookie() {
  if (isAdobeCookieDisabled()) {
    return undefined;
  }

  var adobeCookie = null;

  try {
    adobeCookie = jsCookie.get(_constants.ADOBE.cookieName);
  } catch (error) {
    _logger["default"].warn(error);
  } // To-Do see if we can simplify this and make parseAdobeCookie return undefined


  return parseAdobeCookie(adobeCookie) || undefined;
};

exports.getAdobeCookie = getAdobeCookie;

var parseAdobeCookie = function parseAdobeCookie(cookie) {
  try {
    var decodedCookie = decodeURI(cookie);
    var segments = decodedCookie.split('|');
    var mcidMarkerIndex = segments.indexOf('MCMID');

    if (mcidMarkerIndex !== -1) {
      return segments[mcidMarkerIndex + 1];
    }

    return null;
  } catch (e) {
    return null;
  }
};

exports.parseAdobeCookie = parseAdobeCookie;

var isMcidValid = function isMcidValid(mcid) {
  return mcid && mcid !== 'null';
}; // This is a hacky way to test in live environment what happens when amcv not present


var isAdobeCookieDisabled = function isAdobeCookieDisabled() {
  try {
    return (0, _misc.noWindow)() ? true : window.location.href.includes('rsw_disable_adobe_cookie');
  } catch (error) {
    _logger["default"].warn(error);
  }
};

var init = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var mcid, adobeCookie, formattedAdobeMcid;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            adobeDataPromiseStatus = 'pending'; // Attempt to get MCID from AMCV cookie:

            mcid = null;

            if (!(0, _misc.noWindow)()) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              mcid: null
            });

          case 4:
            adobeCookie = null;

            try {
              adobeCookie = jsCookie.get(_constants.ADOBE.cookieName);
            } catch (error) {
              _logger["default"].warn(error);
            }

            if (adobeCookie) {
              _logger["default"].log('AMCV cookie is present');

              mcid = parseAdobeCookie(adobeCookie);
            } // If we can't get the cookie from demdex, try to get it from our local fallback


            if (!isMcidValid(mcid)) {
              _logger["default"].log('Demdex failed');

              mcid = null;

              try {
                mcid = jsCookie.get(_constants.ADOBE.fallbackCookieName);
              } catch (error) {
                _logger["default"].warn(error);
              } // We don't have anything stored in our local fallback, so generate a new one


              if (!isMcidValid(mcid) && (0, _onetrust.consentGrantedFNC)()) {
                _logger["default"].log('No local cookie, generating local cookie');

                mcid = (0, _generateLocalMcid["default"])();
                jsCookie.set(_constants.ADOBE.fallbackCookieName, mcid, {
                  domain: ".".concat((0, _urls.getRootDomain)(window.location.href))
                }); // set cookie to tell adobe we have created our own cookie

                formattedAdobeMcid = "MCMID|".concat(mcid);

                _logger["default"].log('setting local s_ecid cookie', formattedAdobeMcid, _constants.ADOBE.adobeFallbackCookieName);

                jsCookie.set(_constants.ADOBE.adobeFallbackCookieName, formattedAdobeMcid, {
                  domain: ".".concat((0, _urls.getRootDomain)(window.location.href))
                });
                mcid = mcid;
                jsCookie.set(_constants.ADOBE.legacyCookieName, mcid);
              }
            }

            externalResolve({
              mcid: mcid
            });
            return _context.abrupt("return", {
              mcid: mcid
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init() {
    return _ref2.apply(this, arguments);
  };
}(); // Start the acquisition of the data at bootstrapping, and expose the resulting promise:


exports.init = init;

var getAdobeData = function getAdobeData() {
  return adobeDataPromise;
};

exports.getAdobeData = getAdobeData;

var getAdobeDataStatus = function getAdobeDataStatus() {
  return adobeDataPromiseStatus;
};

exports.getAdobeDataStatus = getAdobeDataStatus;
var _default = {
  getAdobeData: getAdobeData,
  getAdobeDataStatus: getAdobeDataStatus,
  init: init,
  parseAdobeCookie: parseAdobeCookie,
  reset: reset,
  extractCookies: extractCookies
};
exports["default"] = _default;